import script from "./ChatSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./ChatSkeleton.vue?vue&type=style&index=0&id=a943d996&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a943d996"]])

export default __exports__